import { IPagination, IResponseT } from 'interface/base.interface';
import axiosClient from './axiosClient';

const AllocateApi = {
  getDetailCapitalShop: (params: any): Promise<any> => {
    return axiosClient.get('/abe/capital-shop/get-detail', { params });
  },
  importRatioProduct: (data: any): Promise<any> => {
    return axiosClient.post('/abe/capital-shop/import-ratio-product', data);
  },

  importCabinets: (data: any): Promise<any> => {
    return axiosClient.post('/abe/capital-shop/import-cabinets', data);
  },

  getCapitalProduct: (id: any, params?: any): Promise<any> => {
    return axiosClient.get(`/abe/capital-shop/get-capital-product/${id}`, {
      params,
    });
  },

  getRatioCabinet: (params: any): Promise<any> => {
    return axiosClient.get(`/abe/capital-shop/get-list-ratio-cabinet`, {
      params,
    });
  },

  postCapitalProduct: (data: any): Promise<any> => {
    return axiosClient.post('/abe/capital-shop/create-allocation', data);
  },
  putCapitalProduct: (data: any): Promise<any> => {
    return axiosClient.put('/abe/capital-shop/update-allocation', data);
  },

  updateCapitalStatus: (data: any): Promise<any> => {
    return axiosClient.put('/abe/capital-shop/update-status', data);
  },
};

export default AllocateApi;
